import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconShower: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M14 2h2c3.3 0 6 2.7 6 6v13c0 .6-.4 1-1 1s-1-.4-1-1V8c0-2.2-1.8-4-4-4h-2c-1.9 0-3.5 1.3-3.9 3.1 3.3.5 5.9 3.4 5.9 6.9 0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1 0-3.5 2.7-6.5 6.1-6.9C8.5 4.2 11 2 14 2zM9 9c-2.4 0-4.4 1.7-4.9 4h9.8c-.5-2.3-2.5-4-4.9-4zm-5 9c0-.6.4-1 1-1s1 .4 1 1v3c0 .6-.4 1-1 1s-1-.4-1-1v-3zm5-1c-.6 0-1 .4-1 1v3c0 .6.4 1 1 1s1-.4 1-1v-3c0-.6-.4-1-1-1zm3 1c0-.6.4-1 1-1s1 .4 1 1v3c0 .6-.4 1-1 1s-1-.4-1-1v-3z',
    })
  )
}
